import { PaymentMethodUid } from "@/services/marketplace/paymentMethod/paymentMethodSchema";

export function isCard(methodUid: PaymentMethodUid): boolean {
  return methodUid === PaymentMethodUid.Card;
}

export function isOnlinePayment(methodUid: PaymentMethodUid): boolean {
  return methodUid === PaymentMethodUid.OnlinePayment;
}
